import { render, staticRenderFns } from "./work_item_development_relationship_list.vue?vue&type=template&id=9732e042"
import script from "./work_item_development_relationship_list.vue?vue&type=script&lang=js"
export * from "./work_item_development_relationship_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports